// 운영일지
export const dailyReportKeys = {
  all: ["dailyReport"],

  // ---- 운영일지 리스트 ----
  // [GET] 운영일지 검색 조건 받아오기 및 권한 데이터 세팅
  firstSearchParam: () => [...dailyReportKeys.all, "firstSearchParam"],
  // [GET] 운영일지 내역 리스트 검색
  list: (queryData) => [...dailyReportKeys.all, "list", queryData],
  // [GET] 운영일지 상세 데이터
  detail: (queryData) => [...dailyReportKeys.all, "detail", queryData],

  // ---- 운영일지 현황 탭 ----
  // [GET] 회원권 기간 추가 리스트 (운영 일지)
  extend: (queryData) => [...dailyReportKeys.all, "extend", queryData],
  // [GET] 운영일지 월간 매출
  monthlySales: (queryData) => [...dailyReportKeys.all, "monthlySales", queryData],
  // [GET] 운영일지 미납금 현황
  unpaidStatus: (queryData) => [...dailyReportKeys.all, "unpaidStatus", queryData],
  // [GET] 운영일지 미납금 제외 처리 목록
  unpaidExclusion: (queryData) => [...dailyReportKeys.all, "unpaidExclusion", queryData],
  // [GET] 운영일지 환불 요청
  transferReq: (queryData) => [...dailyReportKeys.all, "transferReq", queryData],
  // [GET] 운영일지 시재금 현황
  vaultCash: (queryData) => [...dailyReportKeys.all, "vaultCash", queryData],
};

// 시재금 관리
export const vaultCashKeys = {
  all: ["vaultCash"],
  // [GET] 시재금 입출금 이력
  hist: (queryData) => [...vaultCashKeys.all, "hist", queryData],
  // [GET] 시재금 잔액 조회
  balance: (queryData) => [...vaultCashKeys.all, "balance", queryData],
};

// 급여 관리
export const salaryManageKeys = {
  all: () => ["salaryManage"],
  // [GET] 급여 관리 검색 조건 받아오기 및 권한 데이터 세팅
  searchParam: () => [...salaryManageKeys.all(), "searchParam"],
  // [GET] 급여 관리 내역 리스트 검색
  salaryList: (queryData) => [...salaryManageKeys.all(), "salaryList", queryData],
  // [GET] 급여 리포트 생성 조건 받아오기
  salaryReportCreateParam: () => [...salaryManageKeys.all(), "salaryReportCreateParam"],
};

// 급여 관리 정보
export const salaryInfoKeys = {
  all: () => ["salaryInfo"],
  // [GET] 급여 관리 정보 받아오기
  info: (queryData) => [...salaryInfoKeys.all(), "info", queryData],
  // [GET] 급여 직원별 현황 정보 받아오기
  overallList: (queryData) => [...salaryInfoKeys.all(), "overallList", queryData],
  // [GET] 급여 직원 리스트 콤보 받아오기
  staffCombo: (queryData) => [...salaryInfoKeys.all(), "staffCombo", queryData],
};
